export const MULTI_PATIENT_ENABLED = "multiPatient.enabled"
export const MULTI_PATIENT_START_NEXT_PATIENT_ENABLED = "multiPatient.startNextPatientEnabled"
export const MULTI_PATIENT_REFRESH_INTERVAL_SECONDS = "multiPatient.refreshIntervalSeconds"
export const MULTI_PATIENT_REFRESH_INTERVAL_SECONDS_DEFAULT = 10
export const MULTI_PATIENT_LISTEN_IN_REFRESH_INTERVAL_SECONDS = "multiPatient.listenInRefreshIntervalSeconds"
export const MULTI_PATIENT_LISTEN_IN_REFRESH_INTERVAL_SECONDS_DEFAULT = 5
